export class SSDWidgetServiceConstants {
    public static API_SERVER_URL = 'apiServerUrl';
    public static API_WATER_SERVER_URL = 'apiWaterServerUrl';
    public static SITE_ID_PARAMS = 'siteCpId';
    public static END_DATE = 'endBefore';
    public static START_DATE = 'startOn';
    public static UOM = 'uom';
    public static CULTURE = 'culture';
    public static GET_ASSET_PARAMS = 'getAssetLevelMeasurements';
    public static MEASUREMENTBY_FILTER_ASSET = 'getMeasurementsByFilterForAsset';
    public static FILTER_TYPE = 'measurementFilterType';
    public static VALUE_AGRREGATOR_SERVER_URL = 'valueAggrServiceApiUrl';
}